import React, { useRef } from "react";
import "./Layout.css";
import { WithLayoutContext } from "./LayoutContext";
import { Topbar } from "./Topbar";
// import { Sidebar } from "./Sidebar";
import { Main } from "./Main";
import { Pagination } from "./Pagination";
import { Footer } from "./Footer";
import { LeftSide } from "./LeftSide";
import { RightSide } from "./RightSide";

export const WithLayout = props => {
  const refLang = useRef();
  const { i18n, pagePath, pagination } = props;
  false &&
    console.log(
      "__debug [WithLayout] 😚😚😚😚 props:" +
        JSON.stringify({ i18n, pagePath, pagination })
    );

  return (
    <WithLayoutContext>
      <div
        id="layout"
        onClick={e => {
          if (refLang?.current) refLang.current.closeIcons();
        }}
      >
        <Topbar i18n={i18n} pagePath={pagePath} refLang={refLang} />
        <Pagination pagePath={pagePath} i18n={i18n} pagination={pagination} />
        {/* <Sidebar /> */}
        {/**
         *
         * !IMPORTANT
         * props: pagePath, i18n are NOT passed through Main, because the childrem components receive those from the -template-
         * Main is used only for props.children (for wrapper components such as Topbar and Footer not duplicated)
         * the reason is because initializing context will require a useEffect which causes re-render (blinking when page loads)
         *
         */}
        <Main {...props} />
        <Footer i18n={i18n} pagePath={pagePath} />
        <LeftSide />
        <RightSide />
      </div>
    </WithLayoutContext>
  );
};
